import type { LanguageCopy } from "../api/client";

type Props = {
  copy: LanguageCopy;
  score: number;
  isPrimary: boolean;
};

export function LanguageCard({ copy, score, isPrimary }: Props) {
  // Primary (#1) card gets a brand-green pill; the rest get a quieter chip.
  const scoreChipClass = isPrimary
    ? "bg-[color:var(--color-wren-green)] text-white"
    : "bg-[color:var(--color-wren-light-primary)] text-[color:var(--color-wren-green-dark)]";

  return (
    <div
      className="flex h-full w-full flex-col border border-[color:var(--color-wren-border)] bg-white p-8"
      style={{
        borderRadius: "var(--radius-wren-card)",
        boxShadow: "var(--shadow-wren-button)",
      }}
    >
      <div className="mb-4 flex items-start justify-between gap-4">
        <h3 className="wren-eyebrow text-[0.875rem]">
          {copy.display_name}
        </h3>
        <span
          className={`px-4 py-1 text-[0.6875rem] font-semibold tabular-nums ${scoreChipClass}`}
          style={{ borderRadius: "var(--radius-wren-pill)" }}
        >
          {score}/6
        </span>
      </div>
      <p className="flex-1 text-[1rem] leading-[1.5rem] text-[color:var(--color-wren-light-brown)]">
        {copy.description}
      </p>
    </div>
  );
}
